import React, { useState } from "react";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import styles from "../renewal/Renew.module.css";
import { useDispatch, useSelector } from "react-redux";
import FixedAgent from "../../utils/api/FixedAgent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router";
import Cars from "../../utils/CarList";
import { userDataActions } from "../../store/redux-store/Index";

function CustomerInfo() {
  const [input, setInput] = useState({
    fullname: "",
    phone: "",
    chasisNo: "",
    engineNo: "",
    year: "",
    make: "",
    model: "",
    color: "",
    email: "test@test.com",
    state: "lagos",
    dob: "2/2/24",
    gender: "Male",
    occupation: "Work",
    address: "address",
    plate_no: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const token = useSelector((state) => state.userData.loginData.token);

  const plateNumber = useSelector((state) => state.userData.plateNumber);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const model = Cars?.find((model, index) => model.brand === input.make);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const submitOrderHandler = async () => {
    setIsLoading(true);
    try {
      const makeOrderRes = await FixedAgent.makeManualOrder({
        plate_no: input.plate_no,
        token,
      });
      toast.success(`Successfull`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });

      navigate("/renew");

      setIsLoading(false);
      return makeOrderRes;
    } catch (err) {
      setIsLoading(false);

      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  const addCustomerHandler = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const getUserRoadRes = await FixedAgent.getRoadData({
        plate_no: input.plate_no,
        token,
      });


      const getInsuranceRes = await FixedAgent.getInsuranceData({
        plate_no: input.plate_no,
        token,
      });


      const addNewUser = await FixedAgent.addNewCustomer({
        phone_no: input.phone,
        plate_no: input.plate_no,
        fullname: input.fullname,
        token: token,
        engine_number: input.engineNo,
        chassis: input.chasisNo,
        make: input.make,
        model: input.model,
        year: input.year,
        expiry_date: getInsuranceRes.data.message,
        road_expiry_date: getUserRoadRes.data.data.RwcExp,
        road_message: getUserRoadRes.data.data.message,
        color: input.color,
        state: "lagos",
      });

      submitOrderHandler();

      toast.error(`Customer Added Successfully.`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });

      setIsLoading(false);
      navigate("/customers");
      return addNewUser;
    } catch (err) {
      setIsLoading(false);
      console.log(err?.response?.data?.message);

      if (err?.response?.data?.message === "Unauthenticated") {
        dispatch(userDataActions.logout());
        window.location.reload();
      }
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  return (
    <div>
      <ToastContainer />
      <Navbar title="Renew" />
      <div className={styles.body}>
        <form onSubmit={addCustomerHandler} className={styles.body_inner}>
          <div className={styles.wrapper}>
            <h1 className={styles.wrapper_title}>
              Enter owner’s details to Begin!
            </h1>
            <div className={styles.input_container}>
              <input
                className={styles.input_field}
                type="text"
                name="fullname"
                required
                value={input.fullname}
                onChange={handleInputChange}
                placeholder="Full Name"
              />

              <input
                className={styles.input_field}
                type="text"
                required
                name="phone"
                onChange={handleInputChange}
                value={input.phone}
                placeholder="Phone Number"
              />
            </div>
          </div>
          <div className={styles.wrapper}>
            <h1 className={styles.wrapper_title}>Enter Plate VIN to Begin!</h1>
            <div className={styles.input_container}>
              <input
                className={styles.input_field}
                type="text"
                required
                name="chasisNo"
                onChange={handleInputChange}
                value={input.chasisNo}
                placeholder="VIN/Chasis"
              />
            </div>
          </div>
          <div className={styles.wrapper}>
            <h1 className={styles.wrapper_title}>Year - Make - Model</h1>
            <div className={styles.input_container}>
              <input
                className={styles.input_field}
                type="text"
                required
                name="engineNo"
                onChange={handleInputChange}
                value={input.engineNo}
                placeholder="Engine Number"
              />
              <select
                className={styles.select_field}
                name="color"
                value={input.color}
                required
                onChange={handleInputChange}
              >
                <option value="">Choose Color</option>
                <option value="Air Force blue">Air Force blue</option>
                <option value="Alice blue">Alice blue</option>
                <option value="Alizarin crimson">Alizarin crimson</option>
                <option value="Almond">Almond</option>
                <option value="Amaranth">Amaranth</option>
                <option value="Amber">Amber</option>
                <option value="American rose">American rose</option>
                <option value="Amethyst">Amethyst</option>
                <option value="Android Green">Android Green</option>
                <option value="Anti-flash white">Anti-flash white</option>
                <option value="Antique brass">Antique brass</option>
                <option value="Antique fuchsia">Antique fuchsia</option>
                <option value="Antique white">Antique white</option>
                <option value="Ao">Ao</option>
                <option value="Apple green">Apple green</option>
                <option value="Apricot">Apricot</option>
                <option value="Aqua">Aqua</option>
                <option value="Aquamarine">Aquamarine</option>
                <option value="Army green">Army green</option>
                <option value="Arylide yellow">Arylide yellow</option>
                <option value="Ash">Ash</option>
                <option value="Ash grey">Ash grey</option>
                <option value="Asparagus">Asparagus</option>
                <option value="Atomic tangerine">Atomic tangerine</option>
                <option value="Auburn">Auburn</option>
                <option value="Aureolin">Aureolin</option>
                <option value="AuroMetalSaurus">AuroMetalSaurus</option>
                <option value="Awesome">Awesome</option>
                <option value="Azure">Azure</option>
                <option value="Azure mist/web">Azure mist/web</option>
                <option value="Baby blue">Baby blue</option>
                <option value="Baby blue eyes">Baby blue eyes</option>
                <option value="Baby pink">Baby pink</option>
                <option value="Ball Blue">Ball Blue</option>
                <option value="Banana Mania">Banana Mania</option>
                <option value="Banana yellow">Banana yellow</option>
                <option value="Battleship grey">Battleship grey</option>
                <option value="Bazaar">Bazaar</option>
                <option value="Beau blue">Beau blue</option>
                <option value="Beaver">Beaver</option>
                <option value="Beige">Beige</option>
                <option value="Bisque">Bisque</option>
                <option value="Bistre">Bistre</option>
                <option value="Bittersweet">Bittersweet</option>
                <option value="Black">Black</option>
                <option value="Blanched Almond">Blanched Almond</option>
                <option value="Bleu de France">Bleu de France</option>
                <option value="Blizzard Blue">Blizzard Blue</option>
                <option value="Blond">Blond</option>
                <option value="Blue">Blue</option>
                <option value="Blue Bell">Blue Bell</option>
                <option value="Blue Gray">Blue Gray</option>
                <option value="Blue green">Blue green</option>
                <option value="Blue purple">Blue purple</option>
                <option value="Blue violet">Blue violet</option>
                <option value="Blush">Blush</option>
                <option value="Bole">Bole</option>
                <option value="Bondi blue">Bondi blue</option>
                <option value="Bone">Bone</option>
                <option value="Boston University Red">
                  Boston University Red
                </option>
                <option value="Bottle green">Bottle green</option>
                <option value="Boysenberry">Boysenberry</option>
                <option value="Brandeis blue">Brandeis blue</option>
                <option value="Brass">Brass</option>
                <option value="Brick red">Brick red</option>
                <option value="Bright cerulean">Bright cerulean</option>
                <option value="Bright green">Bright green</option>
                <option value="Bright lavender">Bright lavender</option>
                <option value="Bright maroon">Bright maroon</option>
                <option value="Bright pink">Bright pink</option>
                <option value="Bright turquoise">Bright turquoise</option>
                <option value="Bright ube">Bright ube</option>
                <option value="Brilliant lavender">Brilliant lavender</option>
                <option value="Brilliant rose">Brilliant rose</option>
                <option value="Brink pink">Brink pink</option>
                <option value="British racing green">
                  British racing green
                </option>
                <option value="Bronze">Bronze</option>
                <option value="Brown">Brown</option>
                <option value="Bubble gum">Bubble gum</option>
                <option value="Bubbles">Bubbles</option>
                <option value="Buff">Buff</option>
                <option value="Bulgarian rose">Bulgarian rose</option>
                <option value="Burgundy">Burgundy</option>
                <option value="Burlywood">Burlywood</option>
                <option value="Burnt orange">Burnt orange</option>
                <option value="Burnt sienna">Burnt sienna</option>
                <option value="Burnt umber">Burnt umber</option>
                <option value="Byzantine">Byzantine</option>
                <option value="Byzantium">Byzantium</option>
                <option value="Cadet">Cadet</option>
                <option value="Cadet blue">Cadet blue</option>
                <option value="Cadet grey">Cadet grey</option>
                <option value="Cadmium green">Cadmium green</option>
                <option value="Cadmium orange">Cadmium orange</option>
                <option value="Cadmium red">Cadmium red</option>
                <option value="Cadmium yellow">Cadmium yellow</option>
                <option value="Café au lait">Caf&#233; au lait</option>
                <option value="Café noir">Caf&#233; noir</option>
                <option value="Cal Poly Pomona green">
                  Cal Poly Pomona green
                </option>
                <option value="Cambridge Blue">Cambridge Blue</option>
                <option value="Camel">Camel</option>
                <option value="Camouflage green">Camouflage green</option>
                <option value="Canary">Canary</option>
                <option value="Canary yellow">Canary yellow</option>
                <option value="Candy apple red">Candy apple red</option>
                <option value="Candy pink">Candy pink</option>
                <option value="Capri">Capri</option>
                <option value="Caput mortuum">Caput mortuum</option>
                <option value="Cardinal">Cardinal</option>
                <option value="Caribbean green">Caribbean green</option>
                <option value="Carmine">Carmine</option>
                <option value="Carmine pink">Carmine pink</option>
                <option value="Carmine red">Carmine red</option>
                <option value="Carnation pink">Carnation pink</option>
                <option value="Carnelian">Carnelian</option>
                <option value="Carolina blue">Carolina blue</option>
                <option value="Carrot orange">Carrot orange</option>
                <option value="Celadon">Celadon</option>
                <option value="Celeste">Celeste</option>
                <option value="Celestial blue">Celestial blue</option>
                <option value="Cerise">Cerise</option>
                <option value="Cerise pink">Cerise pink</option>
                <option value="Cerulean">Cerulean</option>
                <option value="Cerulean blue">Cerulean blue</option>
                <option value="CG Blue">CG Blue</option>
                <option value="CG Red">CG Red</option>
                <option value="Chamoisee">Chamoisee</option>
                <option value="Champagne">Champagne</option>
                <option value="Charcoal">Charcoal</option>
                <option value="Chartreuse">Chartreuse</option>
                <option value="Cherry">Cherry</option>
                <option value="Cherry blossom pink">Cherry blossom pink</option>
                <option value="Chestnut">Chestnut</option>
                <option value="Chocolate">Chocolate</option>
                <option value="Chrome yellow">Chrome yellow</option>
                <option value="Cinereous">Cinereous</option>
                <option value="Cinnabar">Cinnabar</option>
                <option value="Cinnamon">Cinnamon</option>
                <option value="Citrine">Citrine</option>
                <option value="Classic rose">Classic rose</option>
                <option value="Cobalt">Cobalt</option>
                <option value="Cocoa brown">Cocoa brown</option>
                <option value="Coffee">Coffee</option>
                <option value="Columbia blue">Columbia blue</option>
                <option value="Cool black">Cool black</option>
                <option value="Cool grey">Cool grey</option>
                <option value="Copper">Copper</option>
                <option value="Copper rose">Copper rose</option>
                <option value="Coquelicot">Coquelicot</option>
                <option value="Coral">Coral</option>
                <option value="Coral pink">Coral pink</option>
                <option value="Coral red">Coral red</option>
                <option value="Cordovan">Cordovan</option>
                <option value="Corn">Corn</option>
                <option value="Cornell Red">Cornell Red</option>
                <option value="Cornflower">Cornflower</option>
                <option value="Cornflower blue">Cornflower blue</option>
                <option value="Cornsilk">Cornsilk</option>
                <option value="Cosmic latte">Cosmic latte</option>
                <option value="Cotton candy">Cotton candy</option>
                <option value="Cream">Cream</option>
                <option value="Crimson">Crimson</option>
                <option value="Crimson glory">Crimson glory</option>
                <option value="Crimson Red">Crimson Red</option>
                <option value="Custom">Custom</option>
                <option value="Cyan">Cyan</option>
                <option value="Daffodil">Daffodil</option>
                <option value="Dandelion">Dandelion</option>
                <option value="Dark blue">Dark blue</option>
                <option value="Dark brown">Dark brown</option>
                <option value="Dark byzantium">Dark byzantium</option>
                <option value="Dark candy apple red">
                  Dark candy apple red
                </option>
                <option value="Dark cerulean">Dark cerulean</option>
                <option value="Dark chestnut">Dark chestnut</option>
                <option value="Dark coral">Dark coral</option>
                <option value="Dark cyan">Dark cyan</option>
                <option value="Dark electric blue">Dark electric blue</option>
                <option value="Dark goldenrod">Dark goldenrod</option>
                <option value="Dark gray">Dark gray</option>
                <option value="Dark green">Dark green</option>
                <option value="Dark jungle green">Dark jungle green</option>
                <option value="Dark khaki">Dark khaki</option>
                <option value="Dark lava">Dark lava</option>
                <option value="Dark lavender">Dark lavender</option>
                <option value="Dark magenta">Dark magenta</option>
                <option value="Dark midnight blue">Dark midnight blue</option>
                <option value="Dark olive green">Dark olive green</option>
                <option value="Dark orange">Dark orange</option>
                <option value="Dark orchid">Dark orchid</option>
                <option value="Dark pastel blue">Dark pastel blue</option>
                <option value="Dark pastel green">Dark pastel green</option>
                <option value="Dark pastel purple">Dark pastel purple</option>
                <option value="Dark pastel red">Dark pastel red</option>
                <option value="Dark pink">Dark pink</option>
                <option value="Dark powder blue">Dark powder blue</option>
                <option value="Dark raspberry">Dark raspberry</option>
                <option value="Dark red">Dark red</option>
                <option value="Dark salmon">Dark salmon</option>
                <option value="Dark scarlet">Dark scarlet</option>
                <option value="Dark sea green">Dark sea green</option>
                <option value="Dark sienna">Dark sienna</option>
                <option value="Dark slate blue">Dark slate blue</option>
                <option value="Dark slate gray">Dark slate gray</option>
                <option value="Dark spring green">Dark spring green</option>
                <option value="Dark tan">Dark tan</option>
                <option value="Dark tangerine">Dark tangerine</option>
                <option value="Dark taupe">Dark taupe</option>
                <option value="Dark terra cotta">Dark terra cotta</option>
                <option value="Dark turquoise">Dark turquoise</option>
                <option value="Dark violet">Dark violet</option>
                <option value="Dartmouth green">Dartmouth green</option>
                <option value="Davy grey">Davy grey</option>
                <option value="Debian red">Debian red</option>
                <option value="Deep carmine">Deep carmine</option>
                <option value="Deep carmine pink">Deep carmine pink</option>
                <option value="Deep carrot orange">Deep carrot orange</option>
                <option value="Deep cerise">Deep cerise</option>
                <option value="Deep champagne">Deep champagne</option>
                <option value="Deep chestnut">Deep chestnut</option>
                <option value="Deep coffee">Deep coffee</option>
                <option value="Deep fuchsia">Deep fuchsia</option>
                <option value="Deep jungle green">Deep jungle green</option>
                <option value="Deep lilac">Deep lilac</option>
                <option value="Deep magenta">Deep magenta</option>
                <option value="Deep peach">Deep peach</option>
                <option value="Deep pink">Deep pink</option>
                <option value="Deep saffron">Deep saffron</option>
                <option value="Deep sky blue">Deep sky blue</option>
                <option value="Denim">Denim</option>
                <option value="Desert">Desert</option>
                <option value="Desert sand">Desert sand</option>
                <option value="Dim gray">Dim gray</option>
                <option value="Dodger blue">Dodger blue</option>
                <option value="Dogwood rose">Dogwood rose</option>
                <option value="Dollar bill">Dollar bill</option>
                <option value="Drab">Drab</option>
                <option value="Duke blue">Duke blue</option>
                <option value="Earth yellow">Earth yellow</option>
                <option value="Ecru">Ecru</option>
                <option value="Eggplant">Eggplant</option>
                <option value="Eggshell">Eggshell</option>
                <option value="Egyptian blue">Egyptian blue</option>
                <option value="Electric blue">Electric blue</option>
                <option value="Electric crimson">Electric crimson</option>
                <option value="Electric cyan">Electric cyan</option>
                <option value="Electric green">Electric green</option>
                <option value="Electric indigo">Electric indigo</option>
                <option value="Electric lavender">Electric lavender</option>
                <option value="Electric lime">Electric lime</option>
                <option value="Electric purple">Electric purple</option>
                <option value="Electric ultramarine">
                  Electric ultramarine
                </option>
                <option value="Electric violet">Electric violet</option>
                <option value="Electric yellow">Electric yellow</option>
                <option value="Emerald">Emerald</option>
                <option value="Eton blue">Eton blue</option>
                <option value="Fallow">Fallow</option>
                <option value="Falu red">Falu red</option>
                <option value="Famous">Famous</option>
                <option value="Fandango">Fandango</option>
                <option value="Fashion fuchsia">Fashion fuchsia</option>
                <option value="Fawn">Fawn</option>
                <option value="Feldgrau">Feldgrau</option>
                <option value="Fern">Fern</option>
                <option value="Fern green">Fern green</option>
                <option value="Ferrari Red">Ferrari Red</option>
                <option value="Field drab">Field drab</option>
                <option value="Fire engine red">Fire engine red</option>
                <option value="Firebrick">Firebrick</option>
                <option value="Flame">Flame</option>
                <option value="Flamingo pink">Flamingo pink</option>
                <option value="Flavescent">Flavescent</option>
                <option value="Flax">Flax</option>
                <option value="Floral white">Floral white</option>
                <option value="Fluorescent orange">Fluorescent orange</option>
                <option value="Fluorescent pink">Fluorescent pink</option>
                <option value="Fluorescent yellow">Fluorescent yellow</option>
                <option value="Folly">Folly</option>
                <option value="Forest green">Forest green</option>
                <option value="French beige">French beige</option>
                <option value="French blue">French blue</option>
                <option value="French lilac">French lilac</option>
                <option value="French rose">French rose</option>
                <option value="Fuchsia">Fuchsia</option>
                <option value="Fuchsia pink">Fuchsia pink</option>
                <option value="Fulvous">Fulvous</option>
                <option value="Fuzzy Wuzzy">Fuzzy Wuzzy</option>
                <option value="Gainsboro">Gainsboro</option>
                <option value="Gamboge">Gamboge</option>
                <option value="Ghost white">Ghost white</option>
                <option value="Ginger">Ginger</option>
                <option value="Glaucous">Glaucous</option>
                <option value="Glitter">Glitter</option>
                <option value="Gold">Gold</option>
                <option value="Golden brown">Golden brown</option>
                <option value="Golden poppy">Golden poppy</option>
                <option value="Golden yellow">Golden yellow</option>
                <option value="Goldenrod">Goldenrod</option>
                <option value="Granny Smith Apple">Granny Smith Apple</option>
                <option value="Gray">Gray</option>
                <option value="Gray asparagus">Gray asparagus</option>
                <option value="Green">Green</option>
                <option value="Green Blue">Green Blue</option>
                <option value="Green yellow">Green yellow</option>
                <option value="Grey">Grey</option>
                <option value="Grullo">Grullo</option>
                <option value="Guppie green">Guppie green</option>
                <option value="Halayà úbe">Halay&#224; &#250;be</option>
                <option value="Han blue">Han blue</option>
                <option value="Han purple">Han purple</option>
                <option value="Hansa yellow">Hansa yellow</option>
                <option value="Harlequin">Harlequin</option>
                <option value="Harvard crimson">Harvard crimson</option>
                <option value="Harvest Gold">Harvest Gold</option>
                <option value="Heart Gold">Heart Gold</option>
                <option value="Heliotrope">Heliotrope</option>
                <option value="Hollywood cerise">Hollywood cerise</option>
                <option value="Honeydew">Honeydew</option>
                <option value="Hooker green">Hooker green</option>
                <option value="Hot magenta">Hot magenta</option>
                <option value="Hot pink">Hot pink</option>
                <option value="Hunter green">Hunter green</option>
                <option value="Icterine">Icterine</option>
                <option value="Inchworm">Inchworm</option>
                <option value="India green">India green</option>
                <option value="Indian red">Indian red</option>
                <option value="Indian yellow">Indian yellow</option>
                <option value="Indigo">Indigo</option>
                <option value="International Klein Blue">
                  International Klein Blue
                </option>
                <option value="International orange">
                  International orange
                </option>
                <option value="Iris">Iris</option>
                <option value="Isabelline">Isabelline</option>
                <option value="Islamic green">Islamic green</option>
                <option value="Ivory">Ivory</option>
                <option value="Jade">Jade</option>
                <option value="Jasmine">Jasmine</option>
                <option value="Jasper">Jasper</option>
                <option value="Jazzberry jam">Jazzberry jam</option>
                <option value="Jonquil">Jonquil</option>
                <option value="June bud">June bud</option>
                <option value="Jungle green">Jungle green</option>
                <option value="Kelly green">Kelly green</option>
                <option value="Khaki">Khaki</option>
                <option value="KU Crimson">KU Crimson</option>
                <option value="La Salle Green">La Salle Green</option>
                <option value="Languid lavender">Languid lavender</option>
                <option value="Lapis lazuli">Lapis lazuli</option>
                <option value="Laser Lemon">Laser Lemon</option>
                <option value="Laurel green">Laurel green</option>
                <option value="Lava">Lava</option>
                <option value="Lavender">Lavender</option>
                <option value="Lavender blue">Lavender blue</option>
                <option value="Lavender blush">Lavender blush</option>
                <option value="Lavender gray">Lavender gray</option>
                <option value="Lavender indigo">Lavender indigo</option>
                <option value="Lavender magenta">Lavender magenta</option>
                <option value="Lavender mist">Lavender mist</option>
                <option value="Lavender pink">Lavender pink</option>
                <option value="Lavender purple">Lavender purple</option>
                <option value="Lavender rose">Lavender rose</option>
                <option value="Lawn green">Lawn green</option>
                <option value="Lemon">Lemon</option>
                <option value="Lemon chiffon">Lemon chiffon</option>
                <option value="Lemon lime">Lemon lime</option>
                <option value="Lemon Yellow">Lemon Yellow</option>
                <option value="Light apricot">Light apricot</option>
                <option value="Light blue">Light blue</option>
                <option value="Light brown">Light brown</option>
                <option value="Light carmine pink">Light carmine pink</option>
                <option value="Light coral">Light coral</option>
                <option value="Light cornflower blue">
                  Light cornflower blue
                </option>
                <option value="Light Crimson">Light Crimson</option>
                <option value="Light cyan">Light cyan</option>
                <option value="Light fuchsia pink">Light fuchsia pink</option>
                <option value="Light goldenrod yellow">
                  Light goldenrod yellow
                </option>
                <option value="Light gray">Light gray</option>
                <option value="Light green">Light green</option>
                <option value="Light khaki">Light khaki</option>
                <option value="Light pastel purple">Light pastel purple</option>
                <option value="Light pink">Light pink</option>
                <option value="Light salmon">Light salmon</option>
                <option value="Light salmon pink">Light salmon pink</option>
                <option value="Light sea green">Light sea green</option>
                <option value="Light sky blue">Light sky blue</option>
                <option value="Light slate gray">Light slate gray</option>
                <option value="Light taupe">Light taupe</option>
                <option value="Light Thulian pink">Light Thulian pink</option>
                <option value="Light yellow">Light yellow</option>
                <option value="Lilac">Lilac</option>
                <option value="Lime">Lime</option>
                <option value="Lime green">Lime green</option>
                <option value="Lincoln green">Lincoln green</option>
                <option value="Linen">Linen</option>
                <option value="Lion">Lion</option>
                <option value="Liver">Liver</option>
                <option value="Lust">Lust</option>
                <option value="Macaroni and Cheese">Macaroni and Cheese</option>
                <option value="Magenta">Magenta</option>
                <option value="Magic mint">Magic mint</option>
                <option value="Magnolia">Magnolia</option>
                <option value="Mahogany">Mahogany</option>
                <option value="Maize">Maize</option>
                <option value="Majorelle Blue">Majorelle Blue</option>
                <option value="Malachite">Malachite</option>
                <option value="Manatee">Manatee</option>
                <option value="Mango Tango">Mango Tango</option>
                <option value="Mantis">Mantis</option>
                <option value="Maroon">Maroon</option>
                <option value="Mauve">Mauve</option>
                <option value="Mauve taupe">Mauve taupe</option>
                <option value="Mauvelous">Mauvelous</option>
                <option value="Maya blue">Maya blue</option>
                <option value="Meat brown">Meat brown</option>
                <option value="Medium aquamarine">Medium aquamarine</option>
                <option value="Medium blue">Medium blue</option>
                <option value="Medium candy apple red">
                  Medium candy apple red
                </option>
                <option value="Medium carmine">Medium carmine</option>
                <option value="Medium champagne">Medium champagne</option>
                <option value="Medium electric blue">
                  Medium electric blue
                </option>
                <option value="Medium jungle green">Medium jungle green</option>
                <option value="Medium lavender magenta">
                  Medium lavender magenta
                </option>
                <option value="Medium orchid">Medium orchid</option>
                <option value="Medium Persian blue">Medium Persian blue</option>
                <option value="Medium purple">Medium purple</option>
                <option value="Medium red violet">Medium red violet</option>
                <option value="Medium sea green">Medium sea green</option>
                <option value="Medium slate blue">Medium slate blue</option>
                <option value="Medium spring bud">Medium spring bud</option>
                <option value="Medium spring green">Medium spring green</option>
                <option value="Medium taupe">Medium taupe</option>
                <option value="Medium teal blue">Medium teal blue</option>
                <option value="Medium turquoise">Medium turquoise</option>
                <option value="Medium violet red">Medium violet red</option>
                <option value="Melon">Melon</option>
                <option value="Midnight blue">Midnight blue</option>
                <option value="Midnight green">Midnight green</option>
                <option value="Mikado yellow">Mikado yellow</option>
                <option value="Mint">Mint</option>
                <option value="Mint cream">Mint cream</option>
                <option value="Mint green">Mint green</option>
                <option value="Misty rose">Misty rose</option>
                <option value="Moccasin">Moccasin</option>
                <option value="Mode beige">Mode beige</option>
                <option value="Moonstone blue">Moonstone blue</option>
                <option value="Mordant red 19">Mordant red 19</option>
                <option value="Moss green">Moss green</option>
                <option value="Mountain Meadow">Mountain Meadow</option>
                <option value="Mountbatten pink">Mountbatten pink</option>
                <option value="MSU Green">MSU Green</option>
                <option value="Mulberry">Mulberry</option>
                <option value="Munsell">Munsell</option>
                <option value="Mustard">Mustard</option>
                <option value="Myrtle">Myrtle</option>
                <option value="Nadeshiko pink">Nadeshiko pink</option>
                <option value="Napier green">Napier green</option>
                <option value="Naples yellow">Naples yellow</option>
                <option value="Navajo white">Navajo white</option>
                <option value="Navy blue">Navy blue</option>
                <option value="Neon Carrot">Neon Carrot</option>
                <option value="Neon fuchsia">Neon fuchsia</option>
                <option value="Neon green">Neon green</option>
                <option value="Non-photo blue">Non-photo blue</option>
                <option value="North Texas Green">North Texas Green</option>
                <option value="Ocean Boat Blue">Ocean Boat Blue</option>
                <option value="Ochre">Ochre</option>
                <option value="Office green">Office green</option>
                <option value="Old gold">Old gold</option>
                <option value="Old lace">Old lace</option>
                <option value="Old lavender">Old lavender</option>
                <option value="Old mauve">Old mauve</option>
                <option value="Old rose">Old rose</option>
                <option value="Olive">Olive</option>
                <option value="Olive Drab">Olive Drab</option>
                <option value="Olive Green">Olive Green</option>
                <option value="Olivine">Olivine</option>
                <option value="Onyx">Onyx</option>
                <option value="Opera mauve">Opera mauve</option>
                <option value="Orange">Orange</option>
                <option value="Orange peel">Orange peel</option>
                <option value="Orange red">Orange red</option>
                <option value="Orange Yellow">Orange Yellow</option>
                <option value="Orchid">Orchid</option>
                <option value="Otter brown">Otter brown</option>
                <option value="Outer Space">Outer Space</option>
                <option value="Outrageous Orange">Outrageous Orange</option>
                <option value="Oxford Blue">Oxford Blue</option>
                <option value="Pacific Blue">Pacific Blue</option>
                <option value="Pakistan green">Pakistan green</option>
                <option value="Palatinate blue">Palatinate blue</option>
                <option value="Palatinate purple">Palatinate purple</option>
                <option value="Pale aqua">Pale aqua</option>
                <option value="Pale blue">Pale blue</option>
                <option value="Pale brown">Pale brown</option>
                <option value="Pale carmine">Pale carmine</option>
                <option value="Pale cerulean">Pale cerulean</option>
                <option value="Pale chestnut">Pale chestnut</option>
                <option value="Pale copper">Pale copper</option>
                <option value="Pale cornflower blue">
                  Pale cornflower blue
                </option>
                <option value="Pale gold">Pale gold</option>
                <option value="Pale goldenrod">Pale goldenrod</option>
                <option value="Pale green">Pale green</option>
                <option value="Pale lavender">Pale lavender</option>
                <option value="Pale magenta">Pale magenta</option>
                <option value="Pale pink">Pale pink</option>
                <option value="Pale plum">Pale plum</option>
                <option value="Pale red violet">Pale red violet</option>
                <option value="Pale robin egg blue">Pale robin egg blue</option>
                <option value="Pale silver">Pale silver</option>
                <option value="Pale spring bud">Pale spring bud</option>
                <option value="Pale taupe">Pale taupe</option>
                <option value="Pale violet red">Pale violet red</option>
                <option value="Pansy purple">Pansy purple</option>
                <option value="Papaya whip">Papaya whip</option>
                <option value="Paris Green">Paris Green</option>
                <option value="Pastel blue">Pastel blue</option>
                <option value="Pastel brown">Pastel brown</option>
                <option value="Pastel gray">Pastel gray</option>
                <option value="Pastel green">Pastel green</option>
                <option value="Pastel magenta">Pastel magenta</option>
                <option value="Pastel orange">Pastel orange</option>
                <option value="Pastel pink">Pastel pink</option>
                <option value="Pastel purple">Pastel purple</option>
                <option value="Pastel red">Pastel red</option>
                <option value="Pastel violet">Pastel violet</option>
                <option value="Pastel yellow">Pastel yellow</option>
                <option value="Patriarch">Patriarch</option>
                <option value="Payne grey">Payne grey</option>
                <option value="Peach">Peach</option>
                <option value="Peach puff">Peach puff</option>
                <option value="Peach yellow">Peach yellow</option>
                <option value="Pear">Pear</option>
                <option value="Pearl">Pearl</option>
                <option value="Pearl Aqua">Pearl Aqua</option>
                <option value="Peridot">Peridot</option>
                <option value="Periwinkle">Periwinkle</option>
                <option value="Persian blue">Persian blue</option>
                <option value="Persian indigo">Persian indigo</option>
                <option value="Persian orange">Persian orange</option>
                <option value="Persian pink">Persian pink</option>
                <option value="Persian plum">Persian plum</option>
                <option value="Persian red">Persian red</option>
                <option value="Persian rose">Persian rose</option>
                <option value="Phlox">Phlox</option>
                <option value="Phthalo blue">Phthalo blue</option>
                <option value="Phthalo green">Phthalo green</option>
                <option value="Piggy pink">Piggy pink</option>
                <option value="Pine green">Pine green</option>
                <option value="Pink">Pink</option>
                <option value="Pink Flamingo">Pink Flamingo</option>
                <option value="Pink pearl">Pink pearl</option>
                <option value="Pink Sherbet">Pink Sherbet</option>
                <option value="Pistachio">Pistachio</option>
                <option value="Platinum">Platinum</option>
                <option value="Plum">Plum</option>
                <option value="Portland Orange">Portland Orange</option>
                <option value="Powder blue">Powder blue</option>
                <option value="Princeton orange">Princeton orange</option>
                <option value="Prussian blue">Prussian blue</option>
                <option value="Psychedelic purple">Psychedelic purple</option>
                <option value="Puce">Puce</option>
                <option value="Pumpkin">Pumpkin</option>
                <option value="Purple">Purple</option>
                <option value="Purple Heart">Purple Heart</option>
                <option value="Purple mountain majesty">
                  Purple mountain majesty
                </option>
                <option value="Purple Mountains Majesty">
                  Purple Mountains Majesty
                </option>
                <option value="Purple pizzazz">Purple pizzazz</option>
                <option value="Purple taupe">Purple taupe</option>
                <option value="Rackley">Rackley</option>
                <option value="Radical Red">Radical Red</option>
                <option value="Raspberry">Raspberry</option>
                <option value="Raspberry glace">Raspberry glace</option>
                <option value="Raspberry pink">Raspberry pink</option>
                <option value="Raspberry rose">Raspberry rose</option>
                <option value="Raw Sienna">Raw Sienna</option>
                <option value="Razzle dazzle rose">Razzle dazzle rose</option>
                <option value="Razzmatazz">Razzmatazz</option>
                <option value="Red">Red</option>
                <option value="Red brown">Red brown</option>
                <option value="Red Orange">Red Orange</option>
                <option value="Red violet">Red violet</option>
                <option value="Rich black">Rich black</option>
                <option value="Rich carmine">Rich carmine</option>
                <option value="Rich electric blue">Rich electric blue</option>
                <option value="Rich lilac">Rich lilac</option>
                <option value="Rich maroon">Rich maroon</option>
                <option value="Rifle green">Rifle green</option>
                <option value="Robins Egg Blue">Robins Egg Blue</option>
                <option value="Rose">Rose</option>
                <option value="Rose bonbon">Rose bonbon</option>
                <option value="Rose ebony">Rose ebony</option>
                <option value="Rose gold">Rose gold</option>
                <option value="Rose madder">Rose madder</option>
                <option value="Rose pink">Rose pink</option>
                <option value="Rose quartz">Rose quartz</option>
                <option value="Rose taupe">Rose taupe</option>
                <option value="Rose vale">Rose vale</option>
                <option value="Rosewood">Rosewood</option>
                <option value="Rosso corsa">Rosso corsa</option>
                <option value="Rosy brown">Rosy brown</option>
                <option value="Royal azure">Royal azure</option>
                <option value="Royal blue">Royal blue</option>
                <option value="Royal fuchsia">Royal fuchsia</option>
                <option value="Royal purple">Royal purple</option>
                <option value="Ruby">Ruby</option>
                <option value="Ruddy">Ruddy</option>
                <option value="Ruddy brown">Ruddy brown</option>
                <option value="Ruddy pink">Ruddy pink</option>
                <option value="Rufous">Rufous</option>
                <option value="Russet">Russet</option>
                <option value="Rust">Rust</option>
                <option value="Sacramento State green">
                  Sacramento State green
                </option>
                <option value="Saddle brown">Saddle brown</option>
                <option value="Safety orange">Safety orange</option>
                <option value="Saffron">Saffron</option>
                <option value="Saint Patrick Blue">Saint Patrick Blue</option>
                <option value="Salmon">Salmon</option>
                <option value="Salmon pink">Salmon pink</option>
                <option value="Sand">Sand</option>
                <option value="Sand dune">Sand dune</option>
                <option value="Sandstorm">Sandstorm</option>
                <option value="Sandy brown">Sandy brown</option>
                <option value="Sandy taupe">Sandy taupe</option>
                <option value="Sap green">Sap green</option>
                <option value="Sapphire">Sapphire</option>
                <option value="Satin sheen gold">Satin sheen gold</option>
                <option value="Scarlet">Scarlet</option>
                <option value="School bus yellow">School bus yellow</option>
                <option value="Screamin Green">Screamin Green</option>
                <option value="Sea blue">Sea blue</option>
                <option value="Sea green">Sea green</option>
                <option value="Seal brown">Seal brown</option>
                <option value="Seashell">Seashell</option>
                <option value="Selective yellow">Selective yellow</option>
                <option value="Sepia">Sepia</option>
                <option value="Shadow">Shadow</option>
                <option value="Shamrock">Shamrock</option>
                <option value="Shamrock green">Shamrock green</option>
                <option value="Shocking pink">Shocking pink</option>
                <option value="Sienna">Sienna</option>
                <option value="Silver">Silver</option>
                <option value="Sinopia">Sinopia</option>
                <option value="Skobeloff">Skobeloff</option>
                <option value="Sky blue">Sky blue</option>
                <option value="Sky magenta">Sky magenta</option>
                <option value="Slate blue">Slate blue</option>
                <option value="Slate gray">Slate gray</option>
                <option value="Smalt">Smalt</option>
                <option value="Smokey topaz">Smokey topaz</option>
                <option value="Smoky black">Smoky black</option>
                <option value="Snow">Snow</option>
                <option value="Spiro Disco Ball">Spiro Disco Ball</option>
                <option value="Spring bud">Spring bud</option>
                <option value="Spring green">Spring green</option>
                <option value="Steel blue">Steel blue</option>
                <option value="Stil de grain yellow">
                  Stil de grain yellow
                </option>
                <option value="Stizza">Stizza</option>
                <option value="Stormcloud">Stormcloud</option>
                <option value="Straw">Straw</option>
                <option value="Sunglow">Sunglow</option>
                <option value="Sunset">Sunset</option>
                <option value="Sunset Orange">Sunset Orange</option>
                <option value="Tan">Tan</option>
                <option value="Tangelo">Tangelo</option>
                <option value="Tangerine">Tangerine</option>
                <option value="Tangerine yellow">Tangerine yellow</option>
                <option value="Taupe">Taupe</option>
                <option value="Taupe gray">Taupe gray</option>
                <option value="Tawny">Tawny</option>
                <option value="TBA">TBA</option>
                <option value="Tea green">Tea green</option>
                <option value="Tea rose">Tea rose</option>
                <option value="Teal">Teal</option>
                <option value="Teal blue">Teal blue</option>
                <option value="Teal green">Teal green</option>
                <option value="Terra cotta">Terra cotta</option>
                <option value="Thistle">Thistle</option>
                <option value="Thulian pink">Thulian pink</option>
                <option value="Tickle Me Pink">Tickle Me Pink</option>
                <option value="Tiffany Blue">Tiffany Blue</option>
                <option value="Tiger eye">Tiger eye</option>
                <option value="Timberwolf">Timberwolf</option>
                <option value="Titanium yellow">Titanium yellow</option>
                <option value="Tomato">Tomato</option>
                <option value="Toolbox">Toolbox</option>
                <option value="Topaz">Topaz</option>
                <option value="Tractor red">Tractor red</option>
                <option value="Trolley Grey">Trolley Grey</option>
                <option value="Tropical rain forest">
                  Tropical rain forest
                </option>
                <option value="True Blue">True Blue</option>
                <option value="Tufts Blue">Tufts Blue</option>
                <option value="Tumbleweed">Tumbleweed</option>
                <option value="Turkish rose">Turkish rose</option>
                <option value="Turquoise">Turquoise</option>
                <option value="Turquoise blue">Turquoise blue</option>
                <option value="Turquoise green">Turquoise green</option>
                <option value="Tuscan red">Tuscan red</option>
                <option value="Twilight lavender">Twilight lavender</option>
                <option value="Tyrian purple">Tyrian purple</option>
                <option value="UA blue">UA blue</option>
                <option value="UA red">UA red</option>
                <option value="Ube">Ube</option>
                <option value="UCLA Blue">UCLA Blue</option>
                <option value="UCLA Gold">UCLA Gold</option>
                <option value="UFO Green">UFO Green</option>
                <option value="Ultra pink">Ultra pink</option>
                <option value="Ultramarine">Ultramarine</option>
                <option value="Ultramarine blue">Ultramarine blue</option>
                <option value="Umber">Umber</option>
                <option value="United Nations blue">United Nations blue</option>
                <option value="University of California Gold">
                  University of California Gold
                </option>
                <option value="Unmellow Yellow">Unmellow Yellow</option>
                <option value="UP Forest green">UP Forest green</option>
                <option value="UP Maroon">UP Maroon</option>
                <option value="Upsdell red">Upsdell red</option>
                <option value="Urobilin">Urobilin</option>
                <option value="USC Cardinal">USC Cardinal</option>
                <option value="USC Gold">USC Gold</option>
                <option value="Utah Crimson">Utah Crimson</option>
                <option value="Vanilla">Vanilla</option>
                <option value="Vegas gold">Vegas gold</option>
                <option value="Venetian red">Venetian red</option>
                <option value="Verdigris">Verdigris</option>
                <option value="Vermilion">Vermilion</option>
                <option value="Veronica">Veronica</option>
                <option value="Violet">Violet</option>
                <option value="Violet Blue">Violet Blue</option>
                <option value="Violet Red">Violet Red</option>
                <option value="Viridian">Viridian</option>
                <option value="Vivid auburn">Vivid auburn</option>
                <option value="Vivid burgundy">Vivid burgundy</option>
                <option value="Vivid cerise">Vivid cerise</option>
                <option value="Vivid tangerine">Vivid tangerine</option>
                <option value="Vivid violet">Vivid violet</option>
                <option value="Warm black">Warm black</option>
                <option value="Waterspout">Waterspout</option>
                <option value="Wenge">Wenge</option>
                <option value="Wheat">Wheat</option>
                <option value="White">White</option>
                <option value="White smoke">White smoke</option>
                <option value="Wild blue yonder">Wild blue yonder</option>
                <option value="Wild Strawberry">Wild Strawberry</option>
                <option value="Wild Watermelon">Wild Watermelon</option>
                <option value="Wine">Wine</option>
                <option value="Wisteria">Wisteria</option>
                <option value="Xanadu">Xanadu</option>
                <option value="Yale Blue">Yale Blue</option>
                <option value="Yellow">Yellow</option>
                <option value="Yellow green">Yellow green</option>
                <option value="Yellow Orange">Yellow Orange</option>
                <option value="Zaffre">Zaffre</option>
                <option value="Zinnwaldite brown">Zinnwaldite brown</option>
              </select>
              <select
                className={styles.select_field}
                name="year"
                required
                onChange={handleInputChange}
                value={input.year}
              >
                <option value="">Choose Year</option>
                {Array.from({ length: 46 }, (_, i) => (
                  <option key={i} value={1980 + i}>
                    {1980 + i}
                  </option>
                ))}
              </select>
              {/* <input
                className={styles.input_field}
                type="text"
                placeholder="Make"
                name="make"
                required
                onChange={handleInputChange}
                value={input.make}
              /> */}
              <select
                className={styles.select_field}
                name="make"
                value={input.make}
                required
                onChange={handleInputChange}
              >
                <option value="">Make</option>
                {Cars.sort((a, b) => a.brand.localeCompare(b.brand)).map(
                  (data, index) => (
                    <option key={data.brand} value={data.brand}>
                      {data.brand}
                    </option>
                  )
                )}
              </select>
              {/* <input
                className={styles.input_field}
                type="text"
                placeholder="Model"
                name="model"
                required
                onChange={handleInputChange}
                value={input.model}
              /> */}

              <select
                className={styles.select_field}
                name="model"
                required
                value={input.model}
                onChange={handleInputChange}
              >
                <option value="">Model</option>
                {model?.models.map((data, index) => (
                  <option value={data}>{data}</option>
                ))}
              </select>

              <input
                className={styles.input_field}
                type="text"
                placeholder="Plate Number"
                name="plate_no"
                required
                onChange={handleInputChange}
                value={plateNumber ? plateNumber : input.plate_no}
              />
            </div>
          </div>
          <button
            disabled={isLoading}
            style={{
              cursor: isLoading ? "not-allowed" : "default",
              opacity: isLoading ? 0.5 : 1,
            }}
            className={styles.submit_button}
          >
            {isLoading ? `Loading...` : `Add Customer`}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default CustomerInfo;
